module.exports = __webpack_public_path__ + "img/772.6bccd009.jpg";